const useBodyContent = () => {
  return {}
}

export default useBodyContent
